import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { authService } from "../firebase";
import { deleteUser } from "firebase/auth"; // 회원 탈퇴 함수 import
import collaboramate_image from "../image/collaboramate_icon.png";
import { Link } from "react-router-dom";
import { deleteDocument } from "./deleteUserData";

const Index = () => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [userUID, setUserUID] = useState(null);

  function handleSubmit(event) {
    event.preventDefault();
    const result = validateEmail(id);
    if (result) {
      signInWithEmailAndPassword(authService, id, pw)
        .then((userCredential) => {
          const user = userCredential.user;
          setUserUID(user.uid); // 로그인 성공 시 userUID 상태 변수 업데이트
        })
        .catch((error) => {
          alert("Login Error! 잘못된 이메일 또는 비밀번호를 입력하셨나요?");
        });
    } else {
      alert("이메일 형식이 맞지 않습니다");
    }
  }

  // 회원 탈퇴 처리 함수
  const handleDeleteAccount = async () => {
    const user = authService.currentUser; // 현재 로그인된 사용자 가져오기
    await deleteDocument(id);
    deleteUser(user)
      .then(() => {
        // 회원 탈퇴 성공 시 추가적인 작업 수행

        alert("그 동안 CollaboraMate를 사용해주셔서 감사드립니다.");
        setId("");
        setPw("");
        setUserUID(null);
      })
      .catch((error) => {
        // 회원 탈퇴 실패 시 에러 처리
        alert("회원 탈퇴 중 문제 발생!");
      });
  };

  const handleUsernameChange = (event) => {
    setId(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPw(event.target.value);
  };

  const validateEmail = (email) => {
    const regex = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@(kw.ac.kr)$/;
    return regex.test(email);
  };

  return (
    <div>
      <p>회원 탈퇴하는 방법</p>
      <p>-----------------</p>
      <p>1. 기존의 이메일, 비밀번호로 로그인 합니다</p>
      <p>
        2. 정상적인 로그인 이후 '회원 탈퇴하기' 버튼을 누르면 정상적으로 회원
        탈퇴됩니다
      </p>
      <p>
        유저의 이메일, 비밀번호로 이루어진 데이터가 삭제되고, 앱에서 입력하신
        정보가 모두 삭제됩니다
      </p>
      <p>작성하셨던 글은 남아있지만, 더 이상 지원할 수 없게 처리됩니다</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            Email:
            <input type="text" value={id} onChange={handleUsernameChange} />
          </label>
        </div>
        <div>
          <label>
            Password:
            <input type="password" value={pw} onChange={handlePasswordChange} />
          </label>
        </div>

        {userUID ? ( // userUID가 존재하고 유효한 경우에만 버튼을 렌더링
          <button onClick={handleDeleteAccount}>회원 탈퇴하기</button>
        ) : (
          <button type="submit">Login</button>
        )}
        <div>문의 메일 : collaboramate@gmail.com</div>
        <Link
          to="https://www.notion.so/collaboramate/CollaboraMate-90933f328cfd4c569c0fbe19f4bdf89c?pvs=4"
          target="_blank"
        >
          <img
            src={collaboramate_image}
            alt="collaboramate_icon"
            style={{ width: "100px", height: "auto" }}
          />
        </Link>
      </form>
    </div>
  );
};

export default Index;
